import request from "utils/newResquest";
export function exprssInfoQuery(params) {
  return request({
    url: "/toc/order-exprss/exprssInfoQuery",
    method: "get",
    params: params
  });
}
export function shopExprssInfoQuery(params) {
  return request({
    url: "/toc/order-exprss/shopExprssInfoQuery",
    method: "get",
    params: params
  });
}

/**
 * 获取配置文档
 // * @param {
 // *  configKey: string 配置键 必传
 // * }
 // * @returns
 // */
export function apiGetByConfigKey(params) {
  return request({
    url: "/basic/platformConfig/getByConfigKey",
    method: "get",
    params: params
  });
}

// 获取京东商品评价
export function apiGetCommentUrl(params) {
  return request({
    url: "/xyl-open/openGoodsApi/getCommentUrl",
    method: "get",
    params: params
  });
}

// 获取短信验证码
export function apiMobileSendSms(data) {
  return request({
    url: "/login/mobile/sendSms",
    method: "post",
    data: data
  });
}
//重置密码
export function apiResetPassword(data) {
  return request({
    url: "/login/mobile/resetPassword",
    method: "post",
    data: data
  });
}
export function apiMobileLogin(data) {
  return request({
    url: "/login/mobile/mobilePasswordLogin",
    method: "post",
    data: data
  });
}
export function apiMobileSmsLogin(data) {
  return request({
    url: "/login/mobile/smsLogin",
    method: "post",
    data: data
  });
}

// 退出登录

export function apiMemberLoginOut(data) {
  return request({
    url: "/member/loginOut",
    method: "post",
    data: data
  });
}

// 营业执照OCR识别
export function apiBusinessLicenseOcr(data) {
  return request({
    url: "/basic/ocr/businessLicense",
    method: "post",
    data: data
  });
}

// 营业执照OCR识别
export function apiQueryByRedis() {
  return request({
    url: "/toc/supplierApply/queryByRedis",
    method: "get"
  });
}

// 身份证OCR识别-正面
export function apiIdCardFrontOcr(data) {
  return request({
    url: "/basic/ocr/idCardFront",
    method: "post",
    data: data
  });
}

// 身份证OCR识别-反面
export function apiIdCardBackOcr(data) {
  return request({
    url: "/basic/ocr/idCardBack",
    method: "post",
    data: data
  });
}

// 银行卡OCR识别
export function apiBankCardOcr(data) {
  return request({
    url: "/basic/ocr/bankCard",
    method: "post",
    data: data
  });
}
export function apiGetSimpleInfo(data) {
  return request({
    url: "/member/getSimpleInfo",
    method: "post",
    data: data
  });
}
export function apiGetPoolGoodsPage(params) {
  return request({
    url: "/goods/getPoolGoodsPage",
    method: "get",
    params: params
  });
}
export function ocrIdCardFront(data) {
  return request({
    url: "/ocr/idCardFront",
    method: "post",
    data: data
  });
}
export function ocrIdCardBack(data) {
  return request({
    url: "/ocr/idCardBack",
    method: "post",
    data: data
  });
}
export function ocrBankCard(data) {
  return request({
    url: "/ocr/bankCard",
    method: "post",
    data: data
  });
}
export function ocrBusinessLicense(data) {
  return request({
    url: "/ocr/businessLicense",
    method: "post",
    data: data
  });
}
export function memberBindFansAPI(params) {
  return request({
    url: "/member/bindFans",
    method: "get",
    params: params
  });
}
export function memberBindMobileAPI(data) {
  return request({
    url: "/login/wx/bindMobile",
    method: "POST",
    data: data
  });
}

/**
 * APP登录 - 通过登录码获取登录信息
 * @param {Object} params - { code: string } 登录码
 * @returns {Promise} 登录信息（token等）
 */
export function apiGetByAppLoginCode(params) {
  return request({
    url: "/login/wx/getByAppLoginCode",
    method: "get",
    params: params
  });
}